<template>
  <div>
    <form
      class="form form_w660 form_pa30 form_m_pa16 form_createOrder"
      @submit.prevent="save"
      v-if="show"
    >
      <div class="form-item mb12">
        <div>
          <p>{{ $t("forms.whoWillAccpetMaster") }}</p>
        </div>
      </div>

      <div class="form-item form-item_flex form-item_between mb24 flex-m-column">
        <div class="form-item_half mb24_m">
          <el-input
            class="form-item__first-name"
            :placeholder="$t('forms.firstName')"
            v-model="request.contact.first_name"
          />
        </div>

        <div class="form-item_half">
          <el-input :placeholder="$t('forms.lastName')" v-model="request.contact.last_name" />
        </div>
      </div>

      <div class="form-item form-item_flex form-item_between mb24 flex-m-column">
        <div class="form-item_half mb24_m">
          <el-input :placeholder="$t('forms.email')" v-model="request.contact.email" />
        </div>

        <div class="form-item_half">
          <vue-tel-input
            v-model="request.contact.phone"
            @validate="checkValue"
            :placeholder="$t('forms.phone')"
            :inputOptions="{ showDialCode: true }"
            mode="international"
          ></vue-tel-input>
        </div>
      </div>

      <div class="mb24 line"></div>

      <div class="form-item form-item_flex mb24">
        <el-select
          v-model="request.service_id"
          :placeholder="$t('forms.selectService')"
          @change="loadWorkload"
        >
          <el-option
            v-for="item in services"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="form-item form-item_flex form-item_between mb24 flex-m-column">
        <div class="form-item_half mb24_m">
          <el-date-picker
            v-model="request.date"
            type="date"
            :placeholder="$t('forms.pickADay')"
            format="dd/MM/yyyy"
            @change="changeTime"
            :pickerOptions="pickerOptions"
            :editable="false"
          ></el-date-picker>
        </div>

        <div class="form-item_half">
          <el-select v-model="request.time" :placeholder="$t('forms.chooseTime')">
            <el-option v-for="item in timeOptions.current" :key="item.id" :value="item.time">
              <span>
                {{ item.time }}
                <span style="font-weight: bold; margin-left: 8px;">
                  {{
                  getPrice(item)
                  }}
                </span>
              </span>
            </el-option>
          </el-select>
        </div>
      </div>

      <div
        class="form-item form-item_rel mb24"
        :class="{
          'address-knife': isInvalidAddress && request.address_1 == null,
        }"
      >
        <el-select
          v-model="request.address_2"
          :placeholder="$t('forms.chooseAddress')"
          :disabled="cantEdit || request.address_1 != null"
          :class="{
            'disabled-input': cantEdit,
          }"
          :clearable="true"
          @change="changeAddressSelect"
          @visible-change="showInput"
          @blur="selectBlur"
        >
          <el-option
            v-for="item in addresses"
            :key="item.id"
            :label="
              `${item.street} ${item.house}, ${item.postcode}, ${item.city}`
            "
            :value="item.id"
          ></el-option>
        </el-select>

        <autocomplete-input
          v-if="showAutocompleteInput"
          @fill="fill"
          @clearInput="clearInput"
          @errorInput="errorInput"
          @resetErrors="resetErrors"
          @blur="autocompleteInputBlur"
          @focus="autocompleteInputFocus"
          :clear="clearFields"
          :placeholder="$t('forms.enterAddress')"
        />

        <span
          v-if="isInvalidAddress && request.address_1 == null"
          class="address-knife__error"
        >{{ $t("alerts.addressError") }}</span>
      </div>

      <div class="form-item mb16">
        <el-input
          type="textarea"
          :rows="5"
          :placeholder="$t('forms.description')"
          v-model="request.description"
          ref="description"
        ></el-input>
      </div>

      <div class="form-item mb24">
        <upload-image @onChange="filesUploaded" />
      </div>

      <div class="form-item">
        <button
          class="btn btn_width btn_mobile-width-100"
          :disabled="!isValid || isSubmitted"
          :class="{
            btn_disabled: !isValid || isSubmitted,
          }"
        >{{ $t("buttons.create") }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

import mainModal from "@/components/modals/mainModal";
import autocompleteModal from "@/components/modals/autocomplete/autocomplete";
import autocompleteInput from "@/components/base/autocomplete/index";
import uploadImage from "@/components/forms/uploadImage";
import checkEmail from "@/helpers/utils/emailCheck";

import {
  required,
  requiredIf,
  minLength,
  sameAs
} from "vuelidate/lib/validators";
import axios from "axios";
import moment from "moment";
import $config from "@/helpers/config/index";

export default {
  name: "create-order-form",
  components: {
    mainModal,
    autocompleteModal,
    autocompleteInput,
    uploadImage
  },
  validations: {
    request: {
      date: {
        required
      },
      time: {
        required
      },
      service_id: {
        required
      },
      contact: {
        first_name: {
          required
        },
        last_name: {
          required
        },
        email: {
          checkEmail,
          required
        },
        phone: {
          required
        }
      },
      address_2: {
        required: requiredIf(function() {
          if (
            this.request.hasOwnProperty("address_1") &&
            this.request.address_1 != null
          )
            return false;

          return true;
        })
      },
      address_1: {
        required: requiredIf(function() {
          if (
            this.request.hasOwnProperty("address_2") &&
            this.request.address_2 != null
          )
            return false;

          return true;
        })
      }
    }
  },
  data() {
    return {
      options: [
        {
          label: "1 Stunde - €100",
          value: "1 Stunde - €100"
        },
        {
          label: "2 Stunde - €200",
          value: "2 Stunde - €200"
        },
        {
          label: "3 Stunde - €300",
          value: "3 Stunde - €300"
        }
      ],
      show: false,
      showAutocompleteInput: false,
      isAutocompleteInputFocused: false,
      autocompletePrevValue: null,
      autocompleteValue: "",
      files: [],
      isValidPhone: false,
      clearFields: false,
      cantEdit: false,
      timeOptions: {
        current: null,
        data: null
      },
      isSubmitted: false,
      isIterated: false,
      filledAddressWithError: false,
      availableDays: []
    };
  },
  computed: {
    ...mapGetters({
      request: "orders/request",
      client: "client/client",
      showAutocomplete: "autocomplete/show",
      services: "services/services",
      addresses: "address/addresses"
    }),
    isValid() {
      return !this.$v.$invalid && this.isValidPhone;
    },
    pickerOptions() {
      return {
        firstDayOfWeek: 1,
        disabledDate: time => {
          const hasMatch = this.availableDays.find(item => {
            item = new Date(item);
            item.setHours(0, 0, 0, 0);
            return item.getTime() === time.getTime();
          });

          if (!hasMatch) {
            return true;
          }
        }
      };
    },
    isInvalidAddress() {
      return this.filledAddressWithError && this.isIterated;
    }
  },
  methods: {
    ...mapMutations({
      clearForm: "orders/clearForm",
      clearOrders: "orders/clearOrders",
      setState: "orders/setState",
      setStateAutocomplete: "autocomplete/setState"
    }),
    ...mapActions({
      createRequest: "orders/createRequest",
      ordersImageUpload: "orders/uploadImage",
      getWorkload: "public/getWorkload"
    }),
    filesUploaded({ images }) {
      this.files = [...images];
    },
    getPrice(item) {
      return item.extra_price == "0"
        ? ""
        : `+${item.extra_price}%  ${this.$t("forms.toThePrice")}`;
    },
    getAddressById(id) {
      let result;

      this.addresses.forEach(element => {
        if (element.id == id) {
          result = element;
        }
      });

      return result;
    },
    prepareFormData() {
      const time = parseInt(this.request.time.split(":")[0]);
      const date = new Date(this.request.date).setHours(time).valueOf() / 1000;

      const phone = this.request.contact.phone.replace(" ", "");
      this.request.contact.phone = phone;

      return {
        contact: this.request.contact,
        address:
          this.request.address_1 == null
            ? this.getAddressById(this.request.address_2)
            : this.request.address_1,

        service_id: this.request.service_id,
        description: this.request.description,

        single: {
          date,
          time_flexible: true
        },
        utm_marks: this.getUTM()
      };
    },
    getUTM() {
      const url = localStorage.getItem("utmUrl");
      if (url == undefined) return;

      return {
        url,
        inbound_type: "Lead form"
      };
    },
    clear() {
      this.clearForm();
      this.files = [];
      this.autocompleteValue = "";
      this.cantEdit = false;
      this.isSubmitted = false;
    },
    async save() {
      if (!this.isValid) {
        return;
      }

      this.isSubmitted = true;

      setTimeout(() => {
        this.isSubmitted = false;
      }, 300);

      const { status, data } = await this.createRequest(this.prepareFormData());

      if (status == 201) {
        this.$log("createOrder_web_completed");

        this.files.forEach(async item => {
          await this.ordersImageUpload({
            id: data.data[0].id,
            form: item.file
          });
        });

        this.$notify({
          title: this.$t("notifications.requestCreated"),
          message: this.$t("notifications.requestCreatedText"),
          duration: 5000
        });

        this.clear();
        this.clearOrders();

        this.clearFields = true;
        this.$router.push({ name: "Orders" });
      }
    },
    // uploadImage(e) {
    //   const files = Array.from(e.target.files);

    //   files.forEach(file => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);

    //     reader.onload = () => {
    //       this.files.push({
    //         id: this.imagesIndex,
    //         file
    //       });

    //       this.images.push({
    //         id: this.imagesIndex,
    //         src: reader.result
    //       });

    //       this.imagesIndex++;
    //     };
    //   });

    //   this.$refs["uploadImage"].value = "";
    // },
    // deleteImage(id) {
    //   this.images = this.images.filter(e => e.id != id);
    //   this.files = this.files.filter(item => item.id != id);
    // },
    fill({ autocompleteValue, address }) {
      this.request.address_1 = address;
      this.autocompleteValue = autocompleteValue;

      this.cantEdit = true;
    },
    checkValue(v) {
      this.isValidPhone = v.valid && v.type == "mobile";
    },
    autocompleteInputFocus() {
      this.isAutocompleteInputFocused = true;
      this.isIterated = true;
    },
    autocompleteInputBlur(v) {
      this.showAutocompleteInput = false;
      this.isAutocompleteInputFocused = false;
      this.request.address_2 = this.autocompletePrevValue;
    },
    selectBlur() {
      if (this.isAutocompleteInputFocused) {
        return;
      }
      this.showAutocompleteInput = false;
      this.request.address_2 = this.autocompletePrevValue;
    },
    showInput(v) {
      if (v) {
        this.autocompletePrevValue = this.request.address_2;
        this.showAutocompleteInput = true;
        this.request.address_2 = null;
      }
    },
    changeAddressSelect(v) {
      setTimeout(() => {
        if (v) {
          this.autocompletePrevValue = v;

          this.request.address_2 = v;
          this.showAutocompleteInput = false;
          this.isAutocompleteInputFocused = false;
        }
      }, 200);
    },
    clearInput() {
      this.cantEdit = false;
    },
    errorInput() {
      this.cantEdit = false;
      this.filledAddressWithError = true;
      this.request.address_1 = null;
    },
    resetErrors() {
      this.cantEdit = false;
      this.request.address_1 = null;
    },
    changeTime(v) {
      const date = moment(v).format("YYYY-MM-DD");
      let isMatch = false;

      this.timeOptions.data.forEach(e => {
        if (e.date == date) {
          this.timeOptions.current = e.slots;
          isMatch = true;
        }
      });

      if (!isMatch) this.timeOptions.current = [];
    },
    async loadWorkload(e) {
      const res = await this.getWorkload({
        service_id: e,
        office_id: this.client.office_id
      });

      this.timeOptions.data = res.data.data;
      this.availableDays = this.timeOptions.data.map(item => item.date);

      this.changeTime(this.request.date || new Date());
    }
  },
  async mounted() {
    this.request.contact = {
      email: this.client.email,
      phone: this.client.phone,
      last_name: this.client.last_name,
      first_name: this.client.first_name,
      confirmed: true
    };

    if (this.services[0]) {
      this.loadWorkload(this.services[0].value);
    }

    this.show = true;

    if (this.addresses != null) {
      if (this.addresses.length > 0) {
        this.request.address_2 = this.addresses[0].id;
      }
    }

    this.$log("createOrder_web_start");
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>

<style lang="scss" scoped>
.address-knife {
  &__error {
    font-size: 12px;
    margin-left: 12px;
    color: #bd1515;
  }
}
</style>

<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

.form_order .el-select {
  width: 100% !important;
}

.form_createOrder #autocomplete {
  width: 100%;
  max-width: 580px;
  padding: 0 15px;
  box-sizing: border-box;
  position: absolute;
  top: 0%;
  left: 0;
}

.address-knife .el-input--suffix .el-input__inner {
  border: 2px solid #bd1515;
}

.address-knife .autocomplete__input {
  border: 2px solid #bd1515;
}
</style>

<style>
.el-select-dropdown__list .selected {
  background: rgba(155, 205, 130, 0.2) !important;
  color: #000 !important;
}

.el-select-dropdown__list .selected::after {
  position: absolute;
  content: "";
  background-image: url(~@/assets/images/check.svg);
  background-position: center;
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  right: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
}

.el-select-dropdown {
  border-radius: 10px;
}

.el-select-dropdown__list {
  padding: 0 !important;
}

.el-select-dropdown__item {
  height: 32px;
}
</style>
